import {
  Component,
  OnInit,
  ViewChild,
  TemplateRef,
  Input,
  Output,
  EventEmitter,
  OnDestroy
} from '@angular/core';
import { LocalDataSource } from 'ng2-smart-table';
import { DefaultValuesMasterConfigService } from './shared/default-values-master.config.service';
import {
  BaseControl,
  OptionsColumns,
  Forma,
  Control,
  InformacionTablaMaestra,
  Option,
  ValoresMaestraPorDefectoSeletor,
  ConfirmComponent,
  EstructuraEspecifica,
  ValoresEspecificos,
  ColumnaMaestra
} from '@app/shared';
import { DefaultValueMasterFormService } from './shared/default-values-master.form.service';
import { CreationDynamicComponentDataService } from '../../shared/creation-dynamic-component.data.service';
import { find } from 'lodash';
import { DefaultValuesMasterDataService } from './shared/default-values-master.data.service';
import { CreationFormDataService } from '../shared/creation-form-data.service';
import { Subject } from 'rxjs';

@Component({
  selector: 'iw-default-values-master',
  templateUrl: './default-values-master.component.html',
  styleUrls: ['./default-values-master.component.scss'],
  providers: [
    DefaultValueMasterFormService,
    CreationDynamicComponentDataService,
    DefaultValuesMasterDataService,
    CreationFormDataService
  ]
})
export class DefaultValuesMasterComponent implements OnInit, OnDestroy {

  // Entrada de las columnas
  @Input() set columnsMaster (columns: OptionsColumns[]) {
    this._columnsMaster = columns;
  }
  // Contiene la forma principal
  @Input() form: Forma;
// Contiene el formulario del control
  @Input() formulario: Control[] = [];
  // Contiene el control a condicionar
  @Input() control: Control;
  // Contiene la maestra configurada al campo
  @Input() set master(m: InformacionTablaMaestra) {
    this._master = m;
    const optionsColumn: Option[] = [];
    if (this._master && this._master.estructura.length) {
      this.master.estructura.forEach(column => {
        optionsColumn.push({
          key: column.alias,
          value: column.id
        });
      });
    }
    this.options['columnsMaster'] = optionsColumn;
  }
  _master: InformacionTablaMaestra;
  // Mensaje de la accion a realizar en el formulario
  actionForm = '';
  // contiene la forma seleccionada
  formSelect: string = null;
  // Contiene el formulario seleccionado
  formularioSelect: string = null;
  // Contiene el tipo de data seleccionado
  typeDataSelect: string = null;
  // Contiene la columna seleccionada
  columnSelect: string = null;
  // Contiene el index que se esta actualizando
  indexUpdated = -1;
  // Define si abre el formulario de la tabla para editar o agregar
  openForm = false;
  // Controla la ejecucion de los cambios en el formulario
  controlChange = false;
  // Define cuando se esta modificando un valor por defecto
  updated = false;
  // Contiene las consultas de las columnas de las maestras
  acomulateColumns: Array<{
    name: string,
    columns: ValoresEspecificos[],
  }> = [];
  // Configuracion de la tabla
  settings = {};
  // Contiene los templates para el formulario
  templates = {};
  // Contiene las opciones del formulario
  options = {};
  // Contiene los valores por defecto configurados
  source: ValoresMaestraPorDefectoSeletor[] = [];
  // Datos para llenar la tabla
  sourceData: LocalDataSource;
  // Formas asociadas
  associatedFormsConsulted: {name: string, form: Forma}[] = [];
  // Contiene los controles de el formulario de asociaciones
  controls: BaseControl<any>[] = [];
  // Contiene la informacion de las diferentes columnas de la maestra seleccionada
  private _columnsMaster: OptionsColumns[] = [];
  // Destruye y gestiona el memory leak
  private destroy: Subject<void> = new Subject<void>();
  // Referencia a la plantilla para el control personalizado de ng-select
  @ViewChild('ngSelect') private ngSelectTpl: TemplateRef<any>;
  // Referencia al componente de confirmación
  @ViewChild('confirm') private confirm: ConfirmComponent;
  // Contiene la maestra configurada al campo
  @Output() defaulValues: EventEmitter<ValoresMaestraPorDefectoSeletor[]> = new EventEmitter();

  constructor(
    private dvmfs: DefaultValueMasterFormService,
    private cdcds: CreationDynamicComponentDataService,
    private cfds: CreationFormDataService,
    private dvmds: DefaultValuesMasterDataService
  ) { }

  ngOnInit() {
    this.templates = {
      select: this.ngSelectTpl,
    };
    const optionsForms: Option[] = [];
    if (this.form.alias) {
      optionsForms.push({
        key: this.form.alias,
        value: this.form.alias
      });
    }
    if (this.form.asociaciones && this.form.asociaciones.length) {
      this.form.asociaciones.forEach(association => {
        optionsForms.push({
          key: association.aliasAsociacion,
          value: association.aliasAsociacion
        });
      });
    }
    this.options['forms'] = optionsForms;
    // Configurando tabla
    const configTable = new DefaultValuesMasterConfigService();
    this.settings = configTable.settings;
    configTable.accion.subscribe((data: any) => {
      if (data.action === 'delete') {
        this.confirm.new({
          question: '¿realmente desea eliminar el registro?',
          labelConfirm: 'Sí',
          labelDecline: 'No'
        }).then(resp => {
          if (resp) {
            this.delete(data.data.index);
          }
        });
      } else {
        this.updateDefaultValue(data.data);
      }
    });
    this.loadValues();
  }

  ngOnDestroy() {
    this.destroy.next();
    this.destroy.complete();
  }

  get columnsMaster() {
    return this._columnsMaster;
  }

  get master() {
    return this._master;
  }

  /**
   * Cierra el formulario de edicion o creacion de los valores por defecto de la maestra
   *
   * @memberof DefaultValuesMasterComponent
   */
  closeForm() {
    this.formSelect = null;
    this.formularioSelect = null;
    this.actionForm = '';
    this.typeDataSelect = null;
    this.columnSelect = null;
    this.indexUpdated = -1;
    this.openForm = false;
    this.updated = false;
    delete this.options['fields'];
    delete this.options['formFormularios'];
  }

  /**
   * Abre el formulario de edicion o creacion de los valores por defecto de la maestra
   *
   * @param {ValoresMaestraPorDefectoSeletor} [data]
   * @memberof DefaultValuesMasterComponent
   */
  openFormValues(data?: ValoresMaestraPorDefectoSeletor) {
    this.actionForm = 'Agregar';
    if (data) {
      this.controls = this.dvmfs.getFormDefaultValuesMaster(this.templates, this.options, data);
    } else {
      this.controls = this.dvmfs.getFormDefaultValuesMaster(this.templates, this.options);
    }
    this.openForm = true;
  }

  /**
   * Controla los diferentes cambios en el formulario para mostrar la informacion correcta
   *
   * @param {*} data
   * @memberof DefaultValuesMasterComponent
   */
  async changeForm(data: any) {
    if (!this.controlChange) {
      let runControls = false;
      this.controlChange = true;
      const temporalForm: ValoresMaestraPorDefectoSeletor = {
        columna: data.change.cboColumn,
        tipo_valor: data.change.cboTipoValor,
        forma: data.change.cboForm,
        formulario: data.change.cboFormulario,
        campo: data.change.cboField,
        valor: data.change.txtValor,
        bloquear: data.change.chkBloquear,
      };
      const parameters: any = {};
      if (data.change.cboTipoValor === 'formulario') {
        if (data.controlChanged === 'cboForm' && this.formSelect !== data.change.cboForm) {
          this.formSelect = data.change.cboForm;
          this.options['fields'] = [];
          temporalForm.formulario = null;
          temporalForm.campo = null;
          this.options['formFormularios'] = await this.optionsSubForm(data.change.cboForm);
          runControls = true;
        } else if (
          (
            data.controlChanged === 'cboFormulario' &&
            this.formularioSelect !== data.change.cboFormulario
          ) ||
          (
            data.controlChanged === 'cboColumn' &&
            data.change.cboFormulario
          )
        ) {
          this.formularioSelect = data.change.cboFormulario;
          temporalForm.campo = null;
          this.options['fields'] = await this.optionsFields(
            data.change.cboForm,
            data.change.cboFormulario,
            data.change.cboColumn
          );
          runControls = true;
        }
      }
      if (
          data.change.cboColumn &&
          data.change.cboTipoValor === 'especifico' &&
          (
            this.typeDataSelect !== data.change.cboTipoValor ||
            this.columnSelect !== data.change.cboColumn
          )
      ) {
        this.typeDataSelect = data.change.cboTipoValor;
        this.columnSelect = data.change.cboColumn;
        if (data.change.cboTipoValor === 'especifico') {
          const column = find(this.master.estructura, {id: data.change.cboColumn});
          if (column) {
            parameters['type'] = column.tipo_campo['nombre'];
            if (column.tipo_campo['nombre'] === 'ngSelect') {
              parameters['options'] = await this.loadingOptionsControl(column);
            }
          }
        }
        runControls = true;
      }
      if (runControls) {
        this.controls = this.dvmfs.getFormDefaultValuesMaster(this.templates, this.options, temporalForm, parameters);
      }
      this.controlChange = false;
    }
  }

  /**
   * Carga el formulario de modificacion
   *
   * @param {ValoresMaestraPorDefectoSeletor} data
   * @memberof DefaultValuesMasterComponent
   */
  async updateDefaultValue(data: ValoresMaestraPorDefectoSeletor) {
    this.actionForm = 'Modificar';
    const parameters = {};
    this.updated = true;
    this.indexUpdated = data.index;
    if (data.tipo_valor === 'formulario') {
      this.formSelect = data.forma;
      this.formularioSelect = data.formulario;
      this.options['formFormularios'] = await this.optionsSubForm(data.forma);
      this.options['fields'] = await this.optionsFields(
        data.forma,
        data.formulario,
        data.columna
      );
    } else {
      const column = find(this.master.estructura, {id: data.columna});
      if (column) {
        parameters['type'] = column.tipo_campo['nombre'];
        if (column.tipo_campo['nombre'] === 'ngSelect') {
          parameters['options'] = column.propiedades['options'];
        }
      }
    }
    this.controls = this.dvmfs.getFormDefaultValuesMaster(this.templates, this.options, data, parameters);
    this.openForm = true;
  }

  /**
   * Carga la informacion de la tabla
   *
   * @memberof DefaultValuesMasterComponent
   */
  loadDataTable() {
    if (this.source && this.source.length) {
      for (let index = 0; index < this.source.length; index++) {
        this.source[index].index = index;
      }
    }
    this.sourceData = new LocalDataSource(this.source);
    this.defaulValues.emit(this.source);
  }

  /**
   * Guarda la informacion del formulario
   *
   * @param {*} data
   * @memberof DefaultValuesMasterComponent
   */
  sended(data: any) {
    const defaultValue: ValoresMaestraPorDefectoSeletor = {
      columna: data.cboColumn,
      tipo_valor: data.cboTipoValor,
      forma: data.cboForm,
      formulario: data.cboFormulario,
      campo: data.cboField,
      valor: data.txtValor,
      bloquear: data.chkBloquear,
    };
    const column = find(this.master.estructura, {id: data.cboColumn});
    if (column) {
      defaultValue.texto_columna = column.nombre;
      if (defaultValue.tipo_valor === 'especifico') {
        if (column.tipo_campo['nombre'] === 'checkbox') {
          if (defaultValue.valor === 'seleccionado') {
            defaultValue.texto_valor = 'Seleccionado';
          } else {
            defaultValue.texto_valor = 'No seleccionado';
          }
        } else if (column.tipo_campo['nombre'] === 'ngSelect') {
          const option = find(column.propiedades['options'], {value: defaultValue.valor}) as Option;
          if (option) {
            defaultValue.texto_valor = String(option.key);
          } else {
            defaultValue.texto_valor = defaultValue.valor;
          }
        } else {
          defaultValue.texto_valor = defaultValue.valor;
        }
      }
    } else {
      defaultValue['textColumn'] = defaultValue.columna;
      if (defaultValue.tipo_valor === 'especifico') {
        defaultValue.texto_valor = defaultValue.valor;
      }
    }
    if (!this.updated) {
      this.source.push(defaultValue);
    } else {
      this.source[this.indexUpdated] = defaultValue;
    }
    this.loadDataTable();
    this.closeForm();
  }

  /**
   * Setea la información configurada en el control
   *
   * @private
   * @memberof DefaultValuesMasterComponent
   */
  private loadValues() {
    if (
      this.control &&
      this.control.propiedades &&
      this.control.propiedades['valores_defecto_maestra'] &&
      this.control.propiedades['valores_defecto_maestra'].length
    ) {
      this.source = this.control.propiedades['valores_defecto_maestra'];
    }
    this.loadDataTable();
  }

  /**
   * Elimina un registro de la tabla
   *
   * @private
   * @param {number} index
   * @memberof DefaultValuesMasterComponent
   */
  private delete(index: number) {
    this.source.splice(index, 1);
    this.loadDataTable();
  }

  /**
   * Retorna las opciones de los formularios dependiendo de la forma seleccionada
   *
   * @private
   * @param {string} nameForm
   * @returns {Promise<Option[]>}
   * @memberof DefaultValuesMasterComponent
   */
  private optionsSubForm(nameForm: string): Promise<Option[]> {
    return new Promise(async (reject, _error) => {
      const subForms: Option[] = [];
      if (this.form.alias === nameForm) {
        if (this.form && this.form.sub_formas && this.form.sub_formas.length) {
          this.form.sub_formas.forEach(subForm => {
            if (subForm.alias) {
              subForms.push({
                key: subForm.alias,
                value: subForm.alias
              });
            }
          });
        }
      } else {
        const association = find(this.form.asociaciones, {aliasAsociacion: nameForm});
        if (association) {
          const formcondictionalSeleted = find(this.associatedFormsConsulted, {id: association.idForma});
          if (!formcondictionalSeleted) {
            const form  = await this.dvmds.getForm(association.idForma);
            if (form) {
              this.associatedFormsConsulted.push({
                name: nameForm,
                form: form
              });
              form.sub_formas.forEach(subForm => {
                if (subForm.alias && !subForm.tabla) {
                  subForms.push({
                    key: subForm.alias,
                    value: subForm.alias,
                  });
                }
              });
            }
          }
        }
      }
      reject(subForms);
    });
  }

  /**
   * Retorna las opciones de los campos dependiendo de el formulario seleccionado
   *
   * @private
   * @param {string} nameForm
   * @param {string} nameSubForm
   * @param {string} nameColumn
   * @returns {Promise<Option[]>}
   * @memberof DefaultValuesMasterComponent
   */
  private optionsFields(nameForm: string, nameSubForm: string, nameColumn: string): Promise<Option[]> {
    return new Promise(async (reject, _error) => {
      const fields: Option[] = [];
      const columnsSelect = find(this.master.estructura, {id: nameColumn});
        if (columnsSelect && typeof columnsSelect.tipo_campo === 'object') {
          if (this.form.alias === nameForm) {
            const subForm = find(this.form.sub_formas, {alias: nameSubForm})
            if (subForm && subForm.campos && subForm.campos.length) {
              subForm.campos.forEach(field => {
                if (field.tipo_campo.nombre === columnsSelect.tipo_campo['nombre']) {
                  fields.push({
                    key: field.alias,
                    value: field.alias
                  });
                }
              });
            }
          } else {
            const formAssociate = find(this.associatedFormsConsulted, {name: nameForm});
            if (formAssociate) {
              const subFormAssociate = find(formAssociate.form.sub_formas, {alias: nameSubForm});
              if (subFormAssociate && subFormAssociate.campos && subFormAssociate.campos.length) {
                subFormAssociate.campos.forEach(field => {
                  if (field.tipo_campo.nombre === columnsSelect.tipo_campo['nombre']) {
                    fields.push({
                      key: field.alias,
                      value: field.alias
                    });
                  }
                });
              }
            }
          }
        }
        reject(fields);
    });
  }

  /**
   * Carga los datos de la maestra del select indicado
   *
   * @private
   * @param {ColumnaMaestra} control
   * @return {*}  {Promise<Array<{key: string, value: number}>>}
   * @memberof DefaultValuesMasterComponent
   */
  private async loadingOptionsControl(control: ColumnaMaestra): Promise<Array<{key: string, value: number}>> {
    return new Promise<Array<{key: string, value: number}>>(async (resolve, _reject) => {
      if (typeof control.tipo_campo === 'object' && control.tipo_campo.nombre === 'ngSelect') {
        const columnsMaster: Array<{
          key: string,
          value: number
        }> = [];
        if (typeof control.maestra_dependencia === 'object') {
          let specificEstructure: EstructuraEspecifica;

          specificEstructure = {
            maestra: String(control.maestra_dependencia.id),
            columnas: [],
            dependencia: []
          };

          let columns: ValoresEspecificos[];

          const colsMaster = find(this.acomulateColumns, {name: control.id.toString()});
          if (!colsMaster) {
            control.propiedades['columnas_seleccionadas'].forEach((col: string, index: number) => {
              const cols = col.split('_');
              const column = Number(cols[0]);
              if (cols.length === 1 && typeof control.maestra_dependencia === 'object') {
                const structure = find(control.maestra_dependencia.estructura, {id: column});
                if (structure) {
                  specificEstructure.columnas.push(column + ' ');
                }
              }
            });

            if (control.propiedades['columnas_seleccionadas'].length) {
              const blockColumns: Array<string[]> = [];
              if (control.propiedades['columnas_seleccionadas']) {
                let columnDependence = '';
                control.propiedades['columnas_seleccionadas'].forEach((col: string, index: number) => {
                  const column = col.split('_');
                  if (column.length > 1) {
                    if (columnDependence !== column[0]) {
                      columnDependence = column[0];
                      const blockColumnsRecolector: Array<string> = [];
                      control.propiedades['columnas_seleccionadas'].forEach((colDep: string, indexDep: number) => {
                        const columnsRef = colDep.split('_');
                        if (columnsRef[0] === columnDependence) {
                          blockColumnsRecolector.push(colDep);
                        }
                      });
                      blockColumns.push(blockColumnsRecolector);
                    }
                  }
                });
                blockColumns.forEach(columnsSeleted => {
                  const history = this.loadingEstructureColumns(
                    control.maestra_dependencia['estructura'],
                    columnsSeleted,
                    Number(columnsSeleted[0].split('_')[0])
                  );

                  if (history) {
                      specificEstructure.dependencia.push(history);
                  }
                });
              }
            }
            columns = await this.cfds.getColumnsSpecificMasterTable(specificEstructure);

            this.acomulateColumns.push({
              name: control.id.toString(),
              columns: columns
            });
          } else {
            columns = colsMaster.columns;
          }

          columns.forEach(column => {
            let labelSelect = '';
            control.propiedades['columnas_seleccionadas'].forEach((col: number, index: any) => {
              if (index > 0) {
                labelSelect += ' / ';
              }
              if (column.valores[col]) {
                labelSelect += column.valores[col] ;
              } else {
                labelSelect += 'No aplica';
              }
            });
            columnsMaster.push({value: column.id, key: labelSelect});
          });
          resolve(columnsMaster);
        } else {
          resolve([]);
        }
      } else {
        resolve([]);
      }
    });
  }

  /**
   * Realiza la estructura para la consulta de las columnas seleccionadas para mostrar en las tablas y selects
   *
   * @private
   * @param {ColumnaMaestra[]} structure
   * @param {Array<string>} columns
   * @param {number} [idDependence=0]
   * @returns {EstructuraEspecifica}
   * @memberof ConditionsComponent
   */
  private loadingEstructureColumns(
    structure: ColumnaMaestra[],
    columns: Array<string>,
    idDependence: number = 0
  ): EstructuraEspecifica {
    let specificEstructure: EstructuraEspecifica;
    const cls: Array<string> = [];
    specificEstructure = {
      maestra: null,
      columnas: [],
      dependencia: []
    };
    columns.forEach(el => {
      cls.push(el);
    });
    for (const field of structure) {
      if (field.tipo_campo['nombre'] === 'ngSelect') {
        if (idDependence !== 0 && idDependence !== field.id) {
          continue;
        }
        specificEstructure.maestra = field.id + ' ';
        cls.forEach((col: string, index: number) => {
          const  cols = col.split('_');
          const column = Number(cols[1]);
          if (cols.length === 2) {
            const dependenc = Number(cols[0]);
            if (typeof field.maestra_dependencia === 'object') {
              const columnField = find(field.maestra_dependencia.estructura, {id: column});
                if (dependenc === field.id) {

                if (columnField) {
                  specificEstructure.columnas.push(column + ' ');
                }
              }
            }
          } else if (cols.length > 2) {
            const cl = cols.slice(1);
            cls[index] = '';
            cl.forEach((el: any, indexCol: number) => {
              cls[index] += el;

              if (indexCol < (cl.length - 1)) {
                cls[index] += '_';
              }

            });
          }
        });
        if (cls.length) {
          const newLevel = this.loadingEstructureColumns(field.maestra_dependencia['estructura'], cls);
          if (newLevel) {
            specificEstructure.dependencia.push(newLevel);
            break;
          }
        }
      }
    }
    if (specificEstructure.maestra && (specificEstructure.columnas.length || specificEstructure.dependencia.length)) {
      return specificEstructure;
    } else {
      return null;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/administration/creation-dynamic-component/creation-form/default-values-master/default-values-master.component.ts